<template>
    <div v-if="serialModel.showTimer" class="text-center">
        <div v-if="!isTimeExpired">
            <div class="text-gray-secondary pb-2">{{ lbl.serial.expire_in }}</div>
            <div class="text-red-1 text-1.75rem" v-html="displayTime"></div>
        </div>
        <div v-else class="text-red-1">{{ lbl.serial.code_expired }}</div>
    </div>
</template>
<script>
import TimerHelper from '@/helper/TimerHelper.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "SerialTimer",
    mixins: [LocaleMixin],
    props: {
        serialModel: Object,
    },
    data: function () {
        return {
            timer: new TimerHelper(),
            displayTime: "",
            isTimeExpired: false,
        };
    },
    created: function () {
        this.initial();
    },
    beforeUnmount: function () {
        if (this.timer.interval) {
            this.timer.stopTimer();
        }
    },
    methods: {
        initial: function () {
            if (this.timer.interval) {
                this.timer.stopTimer();
            }
            let showHours = this.serialModel.expireIn >= 3600;
            let showDays = this.serialModel.expireIn >= 86400;
            this.timer.initialTimer(this.serialModel.expireIn, ':', showHours, showDays);
            if (this.serialModel.showTimer) {
                this.isTimeExpired = false;
                this.timer.runTimer((display) => {
                    this.displayTime = this.formatDisplayTime(display);
                }, () => {
                    this.isTimeExpired = true;
                    this.serialExpired();
                });
            }
        },
        formatDisplayTime: function(timeString) {          
            // ถ้าไม่มีข้อมูลเวลา ให้ return ค่าเดิม
            if (!timeString || typeof timeString !== 'string') {
                return timeString;
            }

            let parts = timeString.split(':');
            
            // ตัด 00 ด้านหน้าทิ้งจนกว่าจะเหลือ 2 หน่วยสุดท้าย หรือเจอค่าที่ไม่ใช่ 00
            while (parts.length > 2 && parseInt(parts[0]) === 0) {
                parts.shift();
            }

            let result = [];
            
            if (parts.length === 4) {
                // รูปแบบ "DD:HH:MM:SS" -> แสดง DD:HH
                let days = parseInt(parts[0]) || 0;
                let hours = parseInt(parts[1]) || 0;
                result.push(`${days.toString().padStart(2, '0')}&nbsp;<span class="text-gray-secondary text-base">${this.localeCode == 1033 && days > 1 ? this.lbl.date.days + 's' : this.lbl.date.days}</span>`);
                result.push(`${hours.toString().padStart(2, '0')}&nbsp;<span class="text-gray-secondary text-base">${this.localeCode == 1033 && hours > 1 ? this.lbl.date.hours + 's' : this.lbl.date.hours}</span>`);
            } else if (parts.length === 3) {
                // รูปแบบ "HH:MM:SS" -> แสดง HH:MM
                let hours = parseInt(parts[0]) || 0;
                let minutes = parseInt(parts[1]) || 0;
                result.push(`${hours.toString().padStart(2, '0')}&nbsp;<span class="text-gray-secondary text-base">${this.localeCode == 1033 && hours > 1 ? this.lbl.date.hours + 's' : this.lbl.date.hours}</span>`);
                result.push(`${minutes.toString().padStart(2, '0')}&nbsp;<span class="text-gray-secondary text-base">${this.localeCode == 1033 && minutes > 1 ? this.lbl.date.minutes + 's' : this.lbl.date.minutes}</span>`);
            } else if (parts.length === 2) {
                // รูปแบบ "MM:SS" -> แสดง MM:SS
                let minutes = parseInt(parts[0]) || 0;
                let seconds = parseInt(parts[1]) || 0;
                result.push(`${minutes.toString().padStart(2, '0')}&nbsp;<span class="text-gray-secondary text-base">${this.localeCode == 1033 && minutes > 1 ? this.lbl.date.minutes + 's' : this.lbl.date.minutes}</span>`);
                result.push(`${seconds.toString().padStart(2, '0')}&nbsp;<span class="text-gray-secondary text-base">${this.localeCode == 1033 && seconds > 1 ? this.lbl.date.seconds + 's' : this.lbl.date.seconds}</span>`);
            } else {
                // กรณีมีค่าวินาทีอย่างเดียว -> แสดง 00m : SSs
                let minutes = 0;
                let seconds = parseInt(parts[0]) || 0;
                result.push(`${minutes.toString().padStart(2, '0')}&nbsp;<span class="text-gray-secondary text-base">${this.localeCode == 1033 && minutes > 1 ? this.lbl.date.minutes + 's' : this.lbl.date.minutes}</span>`);
                result.push(`${seconds.toString().padStart(2, '0')}&nbsp;<span class="text-gray-secondary text-base">${this.localeCode == 1033 && seconds > 1 ? this.lbl.date.seconds + 's' : this.lbl.date.seconds}</span>`);
            }
            let returnFormat = `<div class="grid grid-cols-2 gap-2 justify-center items-center mx-auto" style="width: fit-content;">
                <div class="rounded-lg p-1 bg-gray-F7F7F7 min-w-90px text-center">${result[0]}</div>
                <div class="rounded-lg p-1 bg-gray-F7F7F7 min-w-90px text-center">${result[1]}</div>
                </div>`;
            return returnFormat;
        },
        serialExpired: function () {
            this.$emit("onSerialExpired");
        },
    }
}
</script>
<style lang="scss" scoped>
</style>
